<template>
  <div>
    <div v-if="!initialized" class="app-initializing">
      <div uk-spinner="ratio: 3"></div>
    </div>
    <template v-else>
      <router-view />
    </template>
    <div class="login-modal" ref="loginModal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <Login
          ref="login"
          @login="closeLoginDialog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
import Login from './components/Login.vue'

export default {
  name: 'App',

  components: { Login },

  metaInfo: {
    title: 'Welcome',
    titleTemplate: '%s | Zion Ticket Portal',
  },

  computed: {
    initialized() {
      return this.$store.state.initialized
    },

    loginDialog() {
      return this.$store.state.loginDialog;
    },
  },

  watch: {
    loginDialog(val) {
      this.$nextTick(() => {
        if (val) {
          this.openLoginDialog()
        } else {
          this.closeLoginDialog()
        }
      })
    },
  },

  methods: {
    openLoginDialog() {
      this.loginModal.show()
    },
    closeLoginDialog() {
      this.loginModal.hide()
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.loginModal = UIkit.modal(this.$refs.loginModal, {
        escClose: false,
        bgClose: false,
      })
    })
  },
}
</script>

<style lang="scss" src="./scss/app.scss">
</style>

<style>
.app-initializing {
  align-items: center;
  display: grid;
  height: 97vh;
  justify-content: center;
}

.login-modal .uk-modal-dialog {
  width: 320px;
}
</style>
